import React, { useEffect, useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import LanguageTypes from '../../constants/LanguageTypes';
import DatePicker, { registerLocale } from 'react-datepicker';
import { enGB, nl } from 'date-fns/locale';
import './style/daterangepicker.scss';

registerLocale(LanguageTypes.NL, nl);
registerLocale(LanguageTypes.EN, enGB);

const DateRangePicker = ({ languageId, labels, handleDate, dateSectionType, isDisabled, resetValues, start, end }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const ref = useRef(
        {
            isMounted: false,
            startProps: null,
            endProps: null
        }
    );
    const language = Object.values(LanguageTypes).includes(languageId) ? languageId : LanguageTypes.EN;
    const setDatesFromProps = useCallback(() => {
        if (ref.current.startProps !== start) {
            ref.current.startProps = start;
        }
        if (ref.current.endProps !== end) {
            ref.current.endProps = end;
        }
        if (ref.current.startProps && startDate === null) {
            setStartDate(ref.current.startProps);
        }
        if (ref.current.endProps && endDate === null) {
            setEndDate(ref.current.endProps);
        }

    }, [start, end]);

    const handleDates = useCallback(() => {
        let initialValueSet = false;

        if ((start && start === startDate) || (end && end === endDate)) {
            initialValueSet = true;
        }

        handleDate(startDate, endDate, dateSectionType, initialValueSet);
    }, [startDate, endDate]);

    useEffect(() => {
        setDatesFromProps();
    }, [setDatesFromProps]);

    useEffect(() => {
        if (resetValues) {
            setStartDate(null);
            setEndDate(null);
        }
    }, [resetValues]);

    useEffect(() => {
        if (ref.current.isMounted) {
            if (startDate && !endDate) {
                setEndDate(startDate);
            }

            if ((startDate && endDate) || (startDate === null && endDate === null)) {
                handleDates();

                ref.current.startProps = null;
                ref.current.endProps = null;
            }

        } else {
            ref.current.isMounted = true;
        }

    }, [startDate, endDate, handleDates]);

    return (
        <div>
            <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={ startDate }
                onChange={ date => setStartDate(date) }
                selectsStart
                startDate={ startDate }
                endDate={ endDate }
                maxDate={ endDate }
                placeholderText={ labels.startDate }
                calendarClassName="customDateRangePicker"
                locale={ language }
                disabled={ isDisabled }
                fixedHeight
            />
            <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={ endDate }
                onChange={ date => setEndDate(date) }
                selectsEnd
                startDate={ startDate }
                endDate={ endDate }
                minDate={ startDate }
                placeholderText={ labels.endDate }
                calendarClassName="customDateRangePicker"
                locale={ language }
                disabled={ isDisabled }
                fixedHeight
            />
        </div>
    );
};

export default DateRangePicker;

DateRangePicker.propTypes = {
    languageId: PropTypes.string,
    labels: PropTypes.object,
    handleDate: PropTypes.func,
    dateSectionType: PropTypes.string,
    isDisabled: PropTypes.bool,
    resetValues: PropTypes.bool,
    start: PropTypes.object,
    end: PropTypes.object
};
